module.exports = __webpack_public_path__ + "img/gchallenge.6bc661f3.jpg";